export default "__VITE_ASSET__C_FX7dVL__"